import { useEffect, useState, useMemo, useCallback } from "react";
import { getPlaces } from "../../../../../utils/getStores";
import { TUseModalSelectStore, IStore } from "./types";
import { notifyError, notifySucces } from "../../../../../utils/notifications";
import api from "../../../../../services/api";
import { useClient } from "../../../../../hooks/ClientProvider";
import { useAuth } from "../../../../../hooks/AuthProvider";

const useModalSelectStore = ({
  open,
  userStores,
  closeModal,
  annuity,
  selectedRowKeys,
  reloadPremiumAnnuity,
}: TUseModalSelectStore) => {
  const [stores, setStores] = useState<IStore[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingAnnuity, setLoadingAnnuity] = useState<boolean>(false);
  const [selectedStore, setSelectedStore] = useState<string | undefined>(
    undefined
  );
  const { client } = useClient();
  const { user } = useAuth();

  const userStoreIdSet = useMemo(() => {
    return new Set(userStores || []);
  }, [userStores]);

  const fetchStores = async () => {
    try {
      setLoading(true);
      const loadedStores: IStore[] = await getPlaces(user);

      setStores(loadedStores);
    } catch (error) {
      console.error("Erro ao buscar lojas:", error);
      setStores([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && stores.length === 0) {
      fetchStores();
    }
  }, [userStoreIdSet]);

  const handleSelectChange = (value: string) => {
    setSelectedStore(value);
  };

  const handleEngage = useCallback(async () => {
    try {
      setLoadingAnnuity(true);
      const { data: phones } = await api.get("client_contacts", {
        client_id: client.client.id,
      });

      if (phones.length === 0) {
        notifyError("Erro! Nenhum telefone cadastrado");
        return;
      }
      const hasBonusPhone = phones.find(
        (phone: any) => phone.utilizadoTaxaBonificada
      );

      if (!hasBonusPhone && annuity?.isBonificada) {
        notifyError(
          "Erro! O cliente não possui nenhum celular com disponibilidade para recebimento de bônus. Tente novamente!"
        );
        return;
      }

      if (!selectedStore) {
        notifyError(
          "É necessário selecionar uma loja para contratar uma anuidade"
        );
        return;
      }

      await api.patch(`client/${client.client.id}/annuity`, {
        id_anuidade: selectedRowKeys[0],
        nome_anuidade: annuity?.descricao,
        valor_anuidade: annuity?.valor,
        id_loja: selectedStore,
      });

      notifySucces("Anuidade bonificada foi contratada com sucesso!");
      reloadPremiumAnnuity();
    } catch (error) {
      notifyError("Falha ao contratar anuidade");
    } finally {
      setLoadingAnnuity(false);
      closeModal();
    }
  }, [
    client,
    annuity,
    selectedRowKeys,
    selectedStore,
    reloadPremiumAnnuity,
    closeModal,
  ]);

  return {
    stores,
    loading,
    selectedStore,
    handleSelectChange,
    handleEngage,
    loadingAnnuity,
  };
};

export default useModalSelectStore;
